/* ===== game/boss-isle-art.ts — 섬을 든 것 그림 — 웅크린 돌 거인 · 땅을 짚은 앞팔 둘 · 등의 섬(발판) · 정수리 문양 · 섬 위에 서기(deckLand) ===== */
import { mixin } from '../../engine/core/mixin.js';
import { TS } from '../world.js';
import { Sprites } from '../sprites.js';
import { IK, ikDeck, ikKneel } from '../entity/boss-isle.js';
import { Game } from '../game.js';
import { isleCanvas } from './isle-tiles.js';
import { hzGlow } from './boss-hazard-art.js';
/* ★ 섬은 그림이자 발판이다 — 그리는 자리와 서는 자리가 같은 ikDeck 에서 나온다(한쪽만 고치지 말 것).
   무릎을 꿇으면 몸 전체가 내려가고 땅 밑은 그리지 않는다(다리가 접혀 들어간 것처럼). 멈춘 바위가 아니게 — 등이 숨에 오르내리고 · 섬 나무가 흔들리고 ·
   앞팔이 늘 땅을 짚어 몸을 받친다. 사연: docs/code-history.md#h245 */

type C2 = CanvasRenderingContext2D;
const K = IK.K, BW = IK.W * K, BH = IK.H * K, PW = 320, PH = 160, RUNE = '#9ff0d8';

export const BossIsleArt: Bag = {
  /** 몸(actors 단계 · drawEnemy 가 넘긴다) */
  drawIsle(c: C2, e: Bag, sx: number, sy: number) {
    const im = Sprites.want('isle_keeper'), pim = Sprites.want('isle_keeper_parts');
    if ((!im || !pim) && e.ikIsle) { const d = ikDeck(e), L = e.ikIsle; c.drawImage(L.cv, (d.x0 + d.x1) / 2 - this.cam.x + L.ox - L.cx, d.y - this.cam.y + L.oy - L.top); return true; }   // 몸 그림을 읽는 동안에도 섬은 그 자리에(안 그리면 섬이 잠깐 사라졌다)
    if (!im || !pim) return false;
    const T = this.time || 0, st = Math.min(2, Math.round((e.pf || 0) * 2)), s = e.facing || 1, kn = ikKneel(e);
    const X = sx + e.w / 2, GY = sy + e.h, FY = GY + kn * IK.DROP, breathe = Math.sin(T * 1.2) * 3;
    c.save(); c.imageSmoothingEnabled = false;
    c.beginPath(); c.rect(X - 700, GY - 900, 1400, 900); c.clip();                      // 땅 밑은 안 보인다(무릎 꿇기)
    c.translate(X, FY); c.scale(s * IK.S, IK.S); c.translate(-IK.CX * K, -IK.FOOT * K);
    /* 앞팔 둘 — 어깨에서 땅을 짚는다(뒤쪽 팔이 먼저 · 어둡게) */
    const arm = (i: number) => {
      const [ax, ay] = IK.ARMS[i], drop = (IK.FOOT - ay) * K - kn * IK.DROP / IK.S, L = 56 * K;   // 어깨에서 보이는 땅까지(설계 칸 · 무릎 꿇으면 짧다)
      const a = Math.asin(Math.max(0.1, Math.min(0.95, drop / L))) + Math.sin(T * 0.9 + i) * 0.03;
      c.save(); c.translate(ax * K, ay * K - breathe); c.rotate(a); if (i === 1) c.globalAlpha = 0.85;
      c.drawImage(pim, PW, 0, PW, PH, -8 * K, -20 * K, PW, PH); c.restore();
    };
    arm(1);
    const fr = st * 2 + ((T % 1.6) < 0.8 ? 0 : 1);
    c.drawImage(im, fr * BW, 0, BW, BH, 0, -breathe, BW, BH);
    if (e.flash > 0) { c.save(); c.globalCompositeOperation = 'lighter'; c.globalAlpha = Math.min(0.5, e.flash * 4); c.drawImage(im, fr * BW, 0, BW, BH, 0, -breathe, BW, BH); c.restore(); }
    arm(0);
    c.restore();
    /* 섬 — 발판과 같은 자리(ikDeck) · 숨에 맞춰 살짝 흔들 */
    const d = ikDeck(e), ix = (d.x0 + d.x1) / 2 - this.cam.x, iy = d.y - this.cam.y, L = e.ikIsle;
    if (L) {                                                                          // 세계에서 들어낸 그 섬(game/isle-lift) — 원래 자리에서 이어 옮겨 온다
      c.save(); c.imageSmoothingEnabled = false; c.translate(ix, iy); c.rotate(Math.sin(T * 0.7) * 0.008);
      c.drawImage(L.cv, L.ox - L.cx, L.oy - L.top);
      c.restore();
      if (L.chest && L.chestOff) { L.chest.x = (d.x0 + d.x1) / 2 + L.chestOff[0]; L.chest.y = d.y + L.chestOff[1]; }   // 상자도 섬에 실려 간다
    } else {
      const isle = isleCanvas(Math.round((d.x1 - d.x0) / TS), 7, true, st >= 2);   // 손님 화면 · 섬이 없는 세계 — 하늘 섬 타일로(game/isle-tiles)
      c.save(); c.imageSmoothingEnabled = false; c.translate(ix, iy); c.rotate(Math.sin(T * 0.7) * 0.01); if (s < 0) c.scale(-1, 1);
      if (isle) c.drawImage(isle.cv, -isle.cv.width / 2, -isle.top);
      else { c.scale(IK.S, IK.S); c.drawImage(pim, (st >= 2 ? 2 : 0) * PW, 0, PW, PH, -IK.ISLE.ax * K, -IK.ISLE.top * K, PW, PH); }
      c.restore();
    }
    if (!e.ikIsle) this.drawIsleSea(c, e);                                            // 진짜 바다에 서 있으면 그린 물결은 필요 없다
    e.ikCrown = [X + (IK.CROWN[0] - IK.CX) * K * IK.S * s + this.cam.x, FY - (IK.FOOT - IK.CROWN[1]) * K * IK.S - breathe * IK.S + this.cam.y];
    return true;
  },
  /** 싸우는 동안 발밑에 차오르는 바닷물(actors 단계 · 몸 앞) — 깨어나면 1.5초에 걸쳐 차오르고 파도가 친다. 그림만(움직임에 손대지 않는다) */
  drawIsleSea(c: C2, e: Bag) {
    const T = this.time || 0;
    if (e.ikSea0 === undefined) e.ikSea0 = T;
    e.ikSea = Math.min(1, (T - e.ikSea0) / 1.5);
    const lv = 64 * e.ikSea * (0.8 + 0.2 * Math.sin(T * 0.6)), GY = e.y + e.h - this.cam.y, x0 = e.cx - 760 - this.cam.x, x1 = e.cx + 760 - this.cam.x;
    if (lv < 2) return;
    const wave = (x: number) => Math.sin(x * 0.022 + T * 2.2) * 6 + Math.sin(x * 0.051 - T * 3.1) * 3;
    c.save();
    const g = c.createLinearGradient(0, GY - lv, 0, GY);
    g.addColorStop(0, 'rgba(80,175,205,.62)'); g.addColorStop(1, 'rgba(20,70,100,.85)');
    c.fillStyle = g; c.beginPath(); c.moveTo(x0, GY + 4);
    for (let x = x0; x <= x1; x += 12) c.lineTo(x, GY - lv + wave(x + this.cam.x) * e.ikSea);
    c.lineTo(x1, GY + 4); c.closePath(); c.fill();
    c.strokeStyle = 'rgba(230,250,255,.85)'; c.lineWidth = 2.5; c.beginPath();
    for (let x = x0; x <= x1; x += 12) { const y = GY - lv + wave(x + this.cam.x) * e.ikSea; x === x0 ? c.moveTo(x, y) : c.lineTo(x, y); }
    c.stroke();
    c.fillStyle = 'rgba(240,252,255,.8)';                                        // 물마루 거품
    for (let i = 0; i < 26; i++) { const wx = x0 + ((i * 61 + T * 40) % (x1 - x0)), y = GY - lv + wave(wx + this.cam.x) * e.ikSea; if (wave(wx + this.cam.x + 8) > 3) c.fillRect(wx, y - 3, 3 + (i % 3), 2); }
    c.restore();
  },
  /** 빛(fx 단계) — 정수리 문양(섬 위에 누가 있으면 밝게) */
  drawIsleGlow(f: any) {
    const c: C2 = f.c, T = this.time || 0;
    for (const e of this.ents) {
      if (!e || e.dead || !e.def || e.def.ai !== 'b_isle' || !e.ikCrown) continue;
      const on = (this.players || []).some((q: any) => q && (q._deckT || 0) > T - 0.4);
      c.save(); c.globalCompositeOperation = 'lighter';
      hzGlow(c, e.ikCrown[0] - f.camX, e.ikCrown[1] - f.camY, (on ? 30 : 16) + Math.sin(T * 4) * 3, RUNE, on ? 0.8 : 0.4);
      c.restore();
    }
  },
  /** 섬 위에 서기 — 엔티티 이동 끝(entity.ts move)에서 플레이어만 · 내려오는 중이면 섬 윗면에 세우고 섬과 함께 옮긴다 */
  deckLand(ent: any, prevBottom: number, drop: boolean) {
    if (!this.players || !this.players.includes(ent)) return;
    for (const e of this.ents) {
      if (!e || e.dead || !e.def || e.def.ai !== 'b_isle') continue;
      const d = ikDeck(e);
      if (ent.x + ent.w < d.x0 || ent.x > d.x1) continue;
      const T = this.time || 0, rode = (ent._deckT || 0) > T - 0.1;
      if (rode && ent._deckX !== undefined) ent.x += d.x0 - ent._deckX;      // 섬과 함께 옆으로
      if (!drop && ent.vy >= 0 && prevBottom <= d.y + (rode ? 40 : 8) && ent.y + ent.h >= d.y - 2) {
        ent.y = d.y - ent.h; ent.vy = 0; ent.onGround = true; ent._deckT = T; ent._deckX = d.x0;
      }
    }
  },
};
mixin(Game.prototype, BossIsleArt, true);
